import { attribute, create, fillable, visitable } from 'ember-cli-page-object';
export default create({
  visit: visitable('/private/registries/:registry/edit'),
  name: {
    scope: '[data-test-name]'
  },
  fillInDescription: fillable('[data-test-bio]'),
  submitButton: {
    scope: '[data-test-edit-registry-button]',
    isDisabled: attribute('disabled')
  }
});